import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irembogov-use-template-confirmation-modal',
  templateUrl: './use-template-confirmation-modal.component.html',
  styleUrls: ['./use-template-confirmation-modal.component.scss'],
})
export class UseTemplateConfirmationModalComponent {
  @Input() show = false;
  @Input() templateName = '';

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onBackdropClick(event: Event): void {
    event.stopPropagation();
    this.onCancel();
  }

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
